import WriteIcon from './component'

export default WriteIcon
